import { EmployeeItemTemplate, EmployeeItemTemplateProps } from "./template";

export type EmployeeItemProps = EmployeeItemTemplateProps

export const EmployeeItem = (props: EmployeeItemProps): JSX.Element => {
    return <EmployeeItemTemplate {...props} />;
  };